<script>
  import ProductPrice from '@/components/Ecommerce/Products/ProductPrice'

  export default {
    components: {
      ProductPrice
    },
    props: {
      price: {
        type: Number,
        required: true
      },
      discount: {
        type: Number,
        default: null
      }
    }
  }
</script>

<template>
  <div class="flex pt-4 items-center justify-between border-t border-gray-200">
    <span>
      Subtotaal incl. btw
    </span>
    <ProductPrice
      :price="price"
      :discount="discount"
      big
      show-decimals
    />
  </div>
</template>

<style scoped>

</style>
